<script setup lang="ts">
import { ref, computed, onBeforeMount, onMounted, watch } from 'vue'

interface Props {
    name: string
    post: string
    code: string | number
    imagePath: string
}
const props = defineProps<Props>()
</script>

<template>
    <article class="management-card">
        <div class="management-card__info">
            <NuxtLink :to="`/management/${props.code}`" class="management-card__name">{{ props.name }}</NuxtLink>
            <div class="management-card__post">{{ props.post }}</div>
            <NuxtLink :to="`/management/${props.code}`" class="management-card__button btn btn--default">Узнать больше</NuxtLink>
        </div>
        <NuxtLink class="management-card__image" :to="`/management/${props.code}`">
            <NuxtImg
                :src="props.imagePath"
                :alt="props.name"
                loading="lazy"
                placeholder="/img/loading.gif"
                placeholder-class="loading"
            />
        </NuxtLink>
    </article>
</template>

<style lang="scss" scoped>
.management-card {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 8px;
    border-radius: 24px;
    background: white;

    &__info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        padding: 8px;
    }

    &__name {
        color: #162133;
        font-size: 18px;
        font-weight: 600;
        line-height: 125%;
        margin-bottom: 4px;
        text-decoration: none;
    }

    &__post {
        color: #162133;
        font-size: 12px;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 8px;
    }

    &__text {
        display: none;
    }

    &__button {
        margin-top: auto;
        
    }

    &__image {
        width: 128px;
        min-width: 128px;
        height: 128px;
        border-radius: 16px;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: top;
        }
    }
}

@media screen and (min-width: 767.98px) {
    .management-card {
        flex-direction: column-reverse;
        justify-content: flex-end;
        padding: 0;
        border-radius: 32px;
        height: 100%;

        &__image {
            height: 360px;
            width: 100%;
            border-radius: 24px;
        }     

        &__info {
            padding: 24px;
            flex: 1;
        }

        &__name {
            font-size: 24px;
            font-weight: 600;
            line-height: normal;
            margin-bottom: 8px;
        }

        &__post {
            font-size: 14px;
            font-weight: 500;
            line-height: 140%;
            margin-bottom: 24px;
        }

        &__text {
            display: block;
            color: #6A7784;
            font-size: 14px;
            font-weight: 500;
            line-height: 140%;
            margin-bottom: 24px;
        }
    }
}

@media screen and (min-width: 1199.98px) {
    .management-card {
        &__name {
            font-size: 20px;
        }

        &__image {
            height: 280px;
        }     
    }
}

@media screen and (min-width: 1360px) {
    .management-card {
        &__image {
            height: 318px;
        }
    }
}
</style>